/* Progressive enhancement: tables stay readable and scrollable without JavaScript. */
(() => {
  'use strict';
  if (window.fdArticleA11yLoaded) return;
  window.fdArticleA11yLoaded = true;
  const selector = '.template-article .blog-listview .rte table';
  const updateFocus = wrapper => {
    if (!wrapper.isConnected) return;
    if (wrapper.scrollWidth > wrapper.clientWidth + 1) wrapper.tabIndex = 0;
    else wrapper.removeAttribute('tabindex');
  };
  const observer = typeof ResizeObserver === 'function'
    ? new ResizeObserver(entries => entries.forEach(entry => updateFocus(entry.target)))
    : null;
  const enhance = root => {
    if (!root || typeof root.querySelectorAll !== 'function') return;
    root.querySelectorAll(selector).forEach(table => {
      if (table.closest('.fd-article-table-scroll')) return;
      const wrapper = document.createElement('div');
      wrapper.className = 'fd-article-table-scroll';
      wrapper.setAttribute('role', 'region');
      const fallback = document.documentElement.lang.toLowerCase().startsWith('bg')
        ? 'Таблица в статията – превъртете хоризонтално за всички колони'
        : 'Article table – scroll horizontally to view all columns';
      wrapper.setAttribute('aria-label', table.caption?.textContent?.trim() || fallback);
      table.parentNode.insertBefore(wrapper, table);
      wrapper.appendChild(table);
      updateFocus(wrapper);
      observer?.observe(wrapper);
    });
  };
  if (document.readyState === 'loading')
    document.addEventListener('DOMContentLoaded', () => enhance(document), { once: true });
  else enhance(document);
  document.addEventListener('shopify:section:load', event => enhance(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target?.querySelectorAll?.('.fd-article-table-scroll').forEach(wrapper => observer?.unobserve(wrapper));
  });
  if (!observer) window.addEventListener('resize', () => {
    document.querySelectorAll('.fd-article-table-scroll').forEach(updateFocus);
  }, { passive: true });
})();
